module.exports = __webpack_public_path__ + "img/6001002000.02ed940.webp";